module.exports = __webpack_public_path__ + "static/media/dettaglio-tetto-casetta-di-legno-noleggiocampi.2a45917e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/strutture/extra/casetta/dettaglio-tetto-casetta-di-legno-noleggiocampi.jpg
// module id = 651
// module chunks = 0